// Sticky footer
if (document.querySelector('#footer.sticky-footer')) {
    document.body.classList.add('sticky-footer')
    if (window.matchMedia('(min-width: 1200px)').matches) {
        setTimeout(() => {
            document.documentElement.style.paddingBottom = document.querySelector('#footer.sticky-footer').clientHeight + 'px'
        }, 2000)
    }
}

// Carousel - full-screen on desktop (images)
document.querySelectorAll('.carousel.full-screen .carousel-item img')
    .forEach((img) => {
        const announcementBarHeight = document.querySelector('#announcement-bar')?.clientHeight || 0
        const topbarHeight = document.querySelector('#topbar')?.clientHeight || 0
        const navbarHeight = document.querySelector('#navbar')?.clientHeight || 0
        img.style.height = window.innerHeight - announcementBarHeight - navbarHeight - topbarHeight + 'px'
    })

// Carousel - full-screen on desktop (videos)
document.querySelectorAll('.carousel.full-screen .carousel-item video')
    .forEach((video) => {
        const announcementBarHeight = document.querySelector('#announcement-bar')?.clientHeight || 0
        const topbarHeight = document.querySelector('#topbar')?.clientHeight || 0
        const navbarHeight = document.querySelector('#navbar')?.clientHeight || 0
        video.style.height = window.innerHeight - announcementBarHeight - topbarHeight - navbarHeight + 'px'
    })

// Featured Products - Init SplideJS slider
const initAllSplideFeaturedProducts = () => {
    document.querySelectorAll('.featured-products .splide')
        .forEach((el) => {
            if (el.classList.contains('init')) {
                return false
            }
            el.classList.add('init')
            new Splide(el, {
                arrows: el.dataset.arrows === 'true',
                pagination: el.dataset.pagination === 'true',
                easing: el.dataset.easing,
                speed: Number(el.dataset.speed),
                autoplay: el.dataset.autoplay === 'true',
                interval: Number(el.dataset.interval),
                perMove: Number(el.dataset.perMove),
                rewind: true,
                breakpoints: {
                    [576 - 1]: {
                        perPage: Number(el.dataset.breakpointXs)
                    },
                    [768 - 1]: {
                        perPage: Number(el.dataset.breakpointSm)
                    },
                    [992 - 1]: {
                        perPage: Number(el.dataset.breakpointMd)
                    },
                    [1200 - 1]: {
                        perPage: Number(el.dataset.breakpointLg)
                    },
                    [1400 - 1]: {
                        perPage: Number(el.dataset.breakpointXl)
                    }
                },
                perPage: Number(el.dataset.breakpointXxl)
            }).mount()
        })
}
initAllSplideFeaturedProducts()

// Fancy Image Slider - Init SplideJS slider
const initAllSplideFancyImageSlider = () => {
    document.querySelectorAll('.fancy-image-slider .splide')
        .forEach((el) => {
            if (el.classList.contains('init')) {
                return false
            }
            el.classList.add('init')
            new Splide(el, {
                type: 'loop',
                arrows: el.dataset.arrows === 'true',
                pagination: el.dataset.pagination === 'true',
                easing: el.dataset.easing,
                speed: Number(el.dataset.speed),
                autoplay: el.dataset.autoplay === 'true',
                interval: Number(el.dataset.interval),
                perMove: Number(el.dataset.perMove),
                rewind: true,
                breakpoints: {
                    [576 - 1]: {
                        perPage: Number(el.dataset.breakpointXs)
                    },
                    [768 - 1]: {
                        perPage: Number(el.dataset.breakpointSm)
                    },
                    [992 - 1]: {
                        perPage: Number(el.dataset.breakpointMd)
                    },
                    [1200 - 1]: {
                        perPage: Number(el.dataset.breakpointLg)
                    },
                    [1400 - 1]: {
                        perPage: Number(el.dataset.breakpointXl)
                    }
                },
                perPage: Number(el.dataset.breakpointXxl)
            }).mount()
        })
}
initAllSplideFancyImageSlider()

// Brands - Init SplideJS slider
const initAllBrandsSlider = () => {
    document.querySelectorAll('.brands .splide')
        .forEach((el) => {
            if (el.classList.contains('init')) {
                return false
            }
            el.classList.add('init')
            new Splide(el, {
                type: 'loop',
                arrows: el.dataset.arrows === 'true',
                pagination: el.dataset.pagination === 'true',
                easing: el.dataset.easing,
                speed: Number(el.dataset.speed),
                autoplay: el.dataset.autoplay === 'true',
                interval: Number(el.dataset.interval),
                perMove: Number(el.dataset.perMove),
                rewind: true,
                breakpoints: {
                    [576 - 1]: {
                        perPage: Number(el.dataset.breakpointXs)
                    },
                    [768 - 1]: {
                        perPage: Number(el.dataset.breakpointSm)
                    },
                    [992 - 1]: {
                        perPage: Number(el.dataset.breakpointMd)
                    },
                    [1200 - 1]: {
                        perPage: Number(el.dataset.breakpointLg)
                    },
                    [1400 - 1]: {
                        perPage: Number(el.dataset.breakpointXl)
                    }
                },
                perPage: Number(el.dataset.breakpointXxl)
            }).mount()
        })
}
initAllBrandsSlider()

// Instagram gallery
document.querySelector('#modal-instagram-gallery')?.addEventListener('show.bs.modal', (e) => {
    const {
        url,
        description,
        imgSrc,
        imgWidth,
        imgHeight,
        productUrl,
        productTitle,
        productImgSrc,
        productImgAlt,
        productCompareAtPrice,
        productPrice,
        productPriceVaries,
        textPostDetails,
        textViewPost,
        textOldPrice,
        textPriceFrom,
        textViewProduct
    } = e.relatedTarget.dataset
    const title = `${textPostDetails}`
    const body = `
        <div class="row">
            <div class="col-lg-8 mb-4 mb-lg-0">
                <img class="img-fluid w-100" src="${imgSrc}" alt="" width="${imgWidth}" height="${imgHeight}">
            </div>
            <div class="col-lg-4">
                <div class="card text-center mb-4 ${productTitle ? '' : 'd-none'}">
                    <a href="${productUrl}">
                        <img src="${window.resizeImage(productImgSrc || 'no-image.gif', '600x600', 'center')}" class="card-img-top" alt="${productImgAlt}">
                    </a>
                    <div class="card-body">
                        <h5 class="product-title h6 mb-1">
                            ${productTitle}
                        </h5>
                        <p class="product-price text-body mb-4">
                            <s class="product-price-compare text-muted me-1 ${productCompareAtPrice > productPrice ? '' : 'd-none'}">
                                <span class="visually-hidden">
                                    ${textOldPrice}
                                </span>
                                ${window.formatMoney(productCompareAtPrice)}
                            </s>
                            <span class="product-price-final">
                                <span class="price-from ${productPriceVaries === 'true' ? '' : 'd-none'}">
                                    ${textPriceFrom}
                                </span>
                                ${window.formatMoney(productPrice)}
                            </span>
                        </p>
                        <a href="${productUrl}" class="btn btn-primary btn-sm w-100">
                            ${textViewProduct}
                        </a>
                    </div>
                </div>
                <div class="rte mb-4">
                    ${description}
                </div>
                <a class="btn btn-outline-primary w-100 btn-sm" href="${url}" target="_blank">
                    ${textViewPost}
                </a>
            </div>
        </div>
    `
    e.target.querySelector('.modal-title').innerHTML = title
    e.target.querySelector('.modal-body').innerHTML = body
})

// Newsletter
if (window.location.href.indexOf('?customer_posted=true') > -1) {
    setTimeout(() => {
        document.querySelector('.newsletter').scrollIntoView()
    }, 750)
}

// Listen for changes in theme editor
document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.featured-products')) {
        initAllSplideFeaturedProducts()
    }
    if (e.target.querySelector('.fancy-image-slider')) {
        initAllSplideFancyImageSlider()
    }
    if (e.target.querySelector('.brands')) {
        initAllBrandsSlider()
    }
})

// Animated Counters
const initAnimatedCounters = () => {
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.querySelectorAll('.animated-counter').forEach(counter => {
                    const speed = Number(counter.dataset.speed)

                    const animate = () => {
                        const value = +counter.dataset.value
                        const data = +counter.innerText

                        const time = value / speed
                        if (data < value) {
                            counter.innerText = Math.ceil(data + time)
                            setTimeout(animate, 1)
                        } else {
                            counter.innerText = value
                        }
                    }
                    animate()
                })
            }
        })
    }, { threshold: 0.25 })

    document.querySelectorAll('.animated-counters').forEach((el) => {
        observer.observe(el)
    })
}
initAnimatedCounters()
